import { render, staticRenderFns } from "./sosInfo.vue?vue&type=template&id=7541bd89&scoped=true&"
import script from "./sosInfo.vue?vue&type=script&lang=js&"
export * from "./sosInfo.vue?vue&type=script&lang=js&"
import style0 from "./sosInfo.vue?vue&type=style&index=0&id=7541bd89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541bd89",
  null
  
)

export default component.exports